import React from 'react';
import Title from '../components/common/Title';

const ProfilePage: React.FC = () => {
  return (
    <>
      <Title title="My Profile" />
      <main>
        <div className="container">
          <div style={{ marginTop: '120px', marginBottom: '50px' }}>
            <h1 className="section-title">Your Profile</h1>
            
            <div style={{ display: 'flex', gap: '30px', flexWrap: 'wrap', marginTop: '40px' }}>
              <div style={{ flex: '1', minWidth: '300px' }}>
                <div style={{ 
                  background: 'var(--secondary-color)', 
                  borderRadius: '8px',
                  padding: '30px',
                  marginBottom: '30px'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                    <div style={{ 
                      width: '80px', 
                      height: '80px',
                      borderRadius: '50%',
                      background: 'var(--gray-color)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '2rem',
                      marginRight: '15px'
                    }}>
                      JD
                    </div>
                    <div>
                      <h2 style={{ marginBottom: '5px' }}>John Doe</h2>
                      <p style={{ color: 'var(--light-gray)' }}>Member since 2021</p>
                    </div>
                  </div>
                  
                  <button className="btn btn-primary" style={{ width: '100%' }}>Edit Profile</button>
                </div>
                
                <div style={{ 
                  background: 'var(--secondary-color)', 
                  borderRadius: '8px',
                  padding: '30px'
                }}>
                  <h3 style={{ marginBottom: '20px' }}>Subscription</h3>
                  <div style={{ marginBottom: '15px' }}>
                    <p style={{ fontWeight: 'bold', marginBottom: '5px' }}>Premium Plan</p>
                    <p style={{ color: 'var(--light-gray)' }}>4K + HDR, Watch on 4 devices at once</p>
                  </div>
                  <div style={{ marginBottom: '20px' }}>
                    <p style={{ fontWeight: 'bold', marginBottom: '5px' }}>Billing</p>
                    <p style={{ color: 'var(--light-gray)' }}>Next billing date: May 15, 2025</p>
                  </div>
                  <button className="btn btn-secondary" style={{ width: '100%' }}>Manage Subscription</button>
                </div>
              </div>
              
              <div style={{ flex: '2', minWidth: '300px' }}>
                <div style={{ 
                  background: 'var(--secondary-color)', 
                  borderRadius: '8px',
                  padding: '30px',
                  marginBottom: '30px'
                }}>
                  <h3 style={{ marginBottom: '20px' }}>Account Settings</h3>
                  
                  <div style={{ marginBottom: '20px' }}>
                    <h4 style={{ marginBottom: '10px' }}>Email</h4>
                    <p style={{ color: 'var(--light-gray)', marginBottom: '5px' }}>john.doe@example.com</p>
                    <button className="btn btn-secondary" style={{ fontSize: '0.9rem', padding: '5px 10px' }}>Change Email</button>
                  </div>
                  
                  <div style={{ marginBottom: '20px' }}>
                    <h4 style={{ marginBottom: '10px' }}>Password</h4>
                    <p style={{ color: 'var(--light-gray)', marginBottom: '5px' }}>Last changed 3 months ago</p>
                    <button className="btn btn-secondary" style={{ fontSize: '0.9rem', padding: '5px 10px' }}>Change Password</button>
                  </div>
                  
                  <div>
                    <h4 style={{ marginBottom: '10px' }}>Notification Preferences</h4>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                      <label style={{ display: 'flex', alignItems: 'center' }}>
                        <input type="checkbox" checked style={{ marginRight: '10px' }} /> Email notifications for new releases
                      </label>
                      <label style={{ display: 'flex', alignItems: 'center' }}>
                        <input type="checkbox" checked style={{ marginRight: '10px' }} /> Recommendations based on my viewing history
                      </label>
                      <label style={{ display: 'flex', alignItems: 'center' }}>
                        <input type="checkbox" style={{ marginRight: '10px' }} /> Special offers and discounts
                      </label>
                    </div>
                  </div>
                </div>
                
                <div style={{ 
                  background: 'var(--secondary-color)', 
                  borderRadius: '8px',
                  padding: '30px'
                }}>
                  <h3 style={{ marginBottom: '20px' }}>Viewing History</h3>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <p style={{ fontWeight: 'bold' }}>The Matrix</p>
                        <p style={{ color: 'var(--light-gray)', fontSize: '0.9rem' }}>Watched yesterday</p>
                      </div>
                      <button className="btn btn-secondary" style={{ fontSize: '0.9rem', padding: '5px 10px' }}>Watch Again</button>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <p style={{ fontWeight: 'bold' }}>The Dark Knight</p>
                        <p style={{ color: 'var(--light-gray)', fontSize: '0.9rem' }}>Watched 3 days ago</p>
                      </div>
                      <button className="btn btn-secondary" style={{ fontSize: '0.9rem', padding: '5px 10px' }}>Watch Again</button>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <p style={{ fontWeight: 'bold' }}>Inception</p>
                        <p style={{ color: 'var(--light-gray)', fontSize: '0.9rem' }}>Watched 1 week ago</p>
                      </div>
                      <button className="btn btn-secondary" style={{ fontSize: '0.9rem', padding: '5px 10px' }}>Watch Again</button>
                    </div>
                  </div>
                  <div style={{ marginTop: '20px', textAlign: 'center' }}>
                    <button className="btn btn-primary">View Full History</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default ProfilePage; 